import axios from 'axios';

const BASE = import.meta.env.VITE_API_URL ?? '/api';

// Vendor portal uses NO Authorization header — token is in the URL.
const publicApi = axios.create({ baseURL: BASE });

export interface PortalContext {
  rfq: {
    id: number;
    rfqNo: string;
    rfqDate: string;
    deadline: string | null;
    remarks: string | null;
    items: { id: number; itemName: string; qty: string; unit: string; targetPrice: string | null }[];
  };
  vendor: { id: number; name: string; gstin: string | null; mobile: string | null; email: string | null };
}

export async function fetchPortalContext(token: string): Promise<PortalContext> {
  const r = await publicApi.get<PortalContext>(`/portal/quote/${token}`);
  return r.data;
}

export interface PortalSubmitPayload {
  vendorId: number;
  validUntil?: string;
  paymentTerms?: string;
  remarks?: string;
  items: { rfqItemId: number; unitPrice: number; deliveryDays?: number; remarks?: string }[];
}

export async function submitPortalQuote(token: string, payload: PortalSubmitPayload) {
  const r = await publicApi.post(`/portal/quote/${token}/submit`, payload);
  return r.data;
}
